import { useEffect, useState } from "react";
import { api } from "../../lib/api";

let metaCache = null;
export function usePMeta() {
  const [m, setM] = useState(metaCache);
  useEffect(() => {
    if (!metaCache) api.get("/personalization/meta").then((r) => setM((metaCache = r.data)));
  }, []);
  return m;
}

export const Chips = ({ options, value = [], onChange, multi = true, testId }) => (
  <div className="flex flex-wrap gap-2" data-testid={testId}>
    {Object.entries(options).map(([k, label]) => {
      const on = multi ? value.includes(k) : value === k;
      const toggle = () => onChange(multi ? (on ? value.filter((x) => x !== k) : [...value, k]) : on ? null : k);
      return (
        <button type="button" key={k} onClick={toggle} aria-pressed={on}
          className={`min-h-[40px] rounded-full border px-3.5 py-1.5 text-[13.5px] font-medium transition-colors ${on ? "border-navy bg-navy text-white dark:border-pulse dark:bg-pulse" : "border-border bg-card hover:border-ink"}`}
          data-testid={`${testId}-${k}`}>{label}</button>
      );
    })}
  </div>
);

// Dates are shown and typed as DD.MM.YYYY; stored as ISO YYYY-MM-DD.
export const isoToDmy = (s) => (s && /^\d{4}-\d{2}-\d{2}/.test(s) ? `${s.slice(8, 10)}.${s.slice(5, 7)}.${s.slice(0, 4)}` : "");
export const dmyToIso = (s) => {
  const m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec((s || "").trim());
  if (!m) return "";
  const d = new Date(Date.UTC(+m[3], +m[2] - 1, +m[1]));
  return d.getUTCDate() === +m[1] && d.getUTCMonth() === +m[2] - 1 ? `${m[3]}-${m[2]}-${m[1]}` : "";
};

export const DateField = ({ value, onChange, id, testId, className = "" }) => {
  const [text, setText] = useState(isoToDmy(value));
  useEffect(() => {
    setText(isoToDmy(value));
  }, [value]);
  const bad = text && !dmyToIso(text);
  return (
    <div>
      <input id={id} inputMode="numeric" placeholder="DD.MM.YYYY" value={text} maxLength={10}
        onChange={(e) => { setText(e.target.value); const iso = dmyToIso(e.target.value); if (iso || !e.target.value) onChange(iso); }}
        className={`${className} ${bad ? "border-destructive" : ""}`} aria-invalid={!!bad} data-testid={testId} />
      {bad && <p className="mt-1 text-xs text-destructive">Format: DD.MM.YYYY</p>}
    </div>
  );
};
